// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Player presence bottom sheet — live training coach flow
   Bright + dark via --lt-pp-* tokens (follow BrandContext light/dark). */

.lt-pp-sheet {
  --lt-pp-bg: var(--surface-color, #ffffff);
  --lt-pp-text: var(--text-color, #1a2b3c);
  --lt-pp-muted: var(--text-secondary, #78909c);
  --lt-pp-border: var(--border-color, #e0e6ed);
  --lt-pp-border-soft: color-mix(in srgb, var(--lt-pp-border) 80%, transparent);
  --lt-pp-chip: color-mix(in srgb, var(--lt-pp-text) 5%, var(--lt-pp-bg));
  --lt-pp-input-bg: color-mix(in srgb, var(--lt-pp-text) 4%, var(--lt-pp-bg));
  --lt-pp-row-bg: var(--lt-pp-bg);
  --lt-pp-footer: color-mix(in srgb, var(--lt-pp-text) 3%, var(--lt-pp-bg));
  --lt-pp-hover: color-mix(in srgb, var(--lt-pp-text) 6%, var(--lt-pp-bg));
  --lt-pp-handle: color-mix(in srgb, var(--lt-pp-muted) 55%, transparent);
  --lt-pp-shadow: 0 -12px 40px var(--shadow-color, rgba(8, 119, 188, 0.14));
  --lt-pp-accent: var(--brand-primary, #0877bc);
  --lt-pp-accent-2: var(--brand-secondary, #46528b);
}

.light-mode .lt-pp-sheet,
.lt-pp-sheet.light-mode,
html[data-theme="light"] .lt-pp-sheet {
  --lt-pp-bg: var(--surface-color, #ffffff);
  --lt-pp-text: var(--text-color, #1a2b3c);
  --lt-pp-muted: var(--text-secondary, #64748b);
  --lt-pp-border: #e0e6ed;
  --lt-pp-chip: #f4f7fa;
  --lt-pp-input-bg: #f8fafb;
  --lt-pp-row-bg: #ffffff;
  --lt-pp-footer: #fafbfc;
  --lt-pp-hover: #f0f4f8;
  --lt-pp-shadow: 0 -12px 40px rgba(15, 23, 42, 0.12);
  --lt-pp-accent: var(--brand-primary, #0877bc);
  --lt-pp-accent-2: var(--brand-secondary, #46528b);
}

.dark-mode .lt-pp-sheet,
.lt-pp-sheet.dark-mode,
html[data-theme="dark"] .lt-pp-sheet {
  --lt-pp-bg: var(--surface-color, #111827);
  --lt-pp-text: var(--text-color, #f9fafb);
  --lt-pp-muted: var(--text-secondary, #9ca3af);
  --lt-pp-border: rgba(255, 255, 255, 0.12);
  --lt-pp-chip: rgba(255, 255, 255, 0.06);
  --lt-pp-input-bg: rgba(15, 23, 42, 0.55);
  --lt-pp-row-bg: rgba(255, 255, 255, 0.04);
  --lt-pp-footer: rgba(15, 23, 42, 0.92);
  --lt-pp-hover: rgba(255, 255, 255, 0.08);
  --lt-pp-handle: rgba(148, 163, 184, 0.45);
  --lt-pp-shadow: 0 -12px 40px rgba(0, 0, 0, 0.45);
  /* Club colors lifted toward white so dark palettes stay readable on dark surfaces. */
  --lt-pp-accent: color-mix(in srgb, var(--brand-primary, #0877bc) 62%, #fff);
  --lt-pp-accent-2: color-mix(in srgb, var(--brand-secondary, #46528b) 55%, #fff);
}

.lt-pp-sheet-portal {
  position: fixed;
  inset: 0;
  z-index: 1500;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  box-sizing: border-box;
  animation: lt-pp-backdrop-in 0.22s ease-out;
}

.light-mode .lt-pp-sheet-portal,
.lt-pp-sheet-portal.light-mode,
html[data-theme="light"] .lt-pp-sheet-portal {
  background: rgba(15, 23, 42, 0.4);
}

.dark-mode .lt-pp-sheet-portal,
.lt-pp-sheet-portal.dark-mode,
html[data-theme="dark"] .lt-pp-sheet-portal {
  background: rgba(2, 6, 23, 0.72);
}

.lt-pp-sheet-portal--landscape {
  align-items: center;
  padding-top: max(8px, env(safe-area-inset-top));
  padding-bottom: max(8px, env(safe-area-inset-bottom));
}

.lt-pp-sheet-portal--nested {
  z-index: 1510;
}

@keyframes lt-pp-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lt-pp-sheet {
  width: 100%;
  max-width: min(520px, 100%);
  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--lt-pp-bg, #fff);
  color: var(--lt-pp-text, #1a2b3c);
  border-radius: 20px 20px 0 0;
  box-shadow: var(--lt-pp-shadow, 0 -12px 40px rgba(8, 119, 188, 0.14));
  animation: lt-pp-sheet-up 0.32s cubic-bezier(0.32, 0.72, 0, 1);
  color-scheme: light dark;
}

.lt-pp-sheet-portal--landscape .lt-pp-sheet {
  max-height: min(90dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
  border-radius: 16px;
}

.lt-pp-sheet--nested {
  max-height: min(70dvh, calc(100dvh - env(safe-area-inset-top) - 120px));
}

@keyframes lt-pp-sheet-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.lt-pp-sheet__handle {
  flex-shrink: 0;
  width: 40px;
  height: 4px;
  margin: 10px auto 0;
  border-radius: 999px;
  background: var(--lt-pp-handle, rgba(120, 144, 156, 0.35));
}

.lt-pp-sheet__header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px 8px;
}

.lt-pp-sheet__title-wrap {
  flex: 1 1;
  min-width: 0;
}

.lt-pp-sheet__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.25;
  color: var(--lt-pp-text, #1a2b3c);
}

.lt-pp-sheet__subtitle {
  margin: 2px 0 0;
  font-size: 0.75rem;
  color: var(--lt-pp-muted, #78909c);
  line-height: 1.3;
}

.lt-pp-sheet__close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--lt-pp-muted, #78909c);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-pp-sheet__close:hover {
  background: var(--lt-pp-hover, #f0f4f8);
  color: var(--lt-pp-accent);
}

.lt-pp-sheet__toolbar {
  flex-shrink: 0;
  padding: 0 16px 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid var(--lt-pp-border-soft, #eef2f6);
}

/* Compact header bar: group + title on the left, actions on the right. */
.lt-pp-bar {
  --lt-pp-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 8px 16px;
}

.lt-pp-bar__text {
  flex: 1 1;
  min-width: 0;
}

.lt-pp-bar__kicker {
  margin: 0;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  line-height: 1.3;
  color: var(--lt-pp-accent);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-pp-bar__title {
  margin: 0;
  font-family: var(--lt-pp-display);
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.05;
  color: var(--lt-pp-text, #1a2b3c);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-pp-bar__icon-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: 1px solid color-mix(in srgb, var(--lt-pp-accent) 40%, transparent);
  border-radius: 10px;
  background: color-mix(in srgb, var(--lt-pp-accent) 10%, transparent);
  color: var(--lt-pp-accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.lt-pp-bar__icon-btn:hover {
  background: color-mix(in srgb, var(--lt-pp-accent) 20%, transparent);
}

.lt-pp-bar__done {
  flex-shrink: 0;
  height: 36px;
  padding: 0 16px;
  border: none;
  border-radius: 10px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
}

.dark-mode .lt-pp-bar__done,
.lt-pp-sheet.dark-mode .lt-pp-bar__done,
html[data-theme="dark"] .lt-pp-bar__done {
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--lt-pp-accent) 55%, transparent);
}

.lt-pp-bar__done:hover {
  filter: brightness(1.06);
}

.lt-pp-bar__icon-btn:focus-visible,
.lt-pp-bar__done:focus-visible,
.lt-pp-tally__cell:focus-visible,
.lt-pp-sheet__sort-select:focus-visible {
  outline: 2px solid var(--lt-pp-accent);
  outline-offset: 2px;
}

/* Scoreboard tally: each cell filters the list; tap again to show all. */
.lt-pp-tally {
  display: flex;
  border: 1px solid color-mix(in srgb, var(--lt-pp-accent) 30%, var(--lt-pp-border, #e0e6ed));
  border-radius: 10px;
  overflow: hidden;
}

.lt-pp-tally__cell {
  --lt-pp-tone: #2e7d32;
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  padding: 6px 8px;
  border: none;
  border-top: 3px solid transparent;
  background: var(--lt-pp-row-bg, #fff);
  font: inherit;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.lt-pp-tally__cell + .lt-pp-tally__cell {
  border-left: 1px solid var(--lt-pp-border, #e0e6ed);
}

.lt-pp-tally__cell--unmarked {
  --lt-pp-tone: #e65100;
}

.lt-pp-tally__cell--absent {
  --lt-pp-tone: #c62828;
}

.lt-pp-tally__cell--active {
  border-top-color: var(--lt-pp-tone);
  background: color-mix(in srgb, var(--lt-pp-tone) 10%, var(--lt-pp-bg, #fff));
}

.lt-pp-tally__value {
  font-family: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  font-size: 1.3rem;
  font-weight: 700;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--lt-pp-tone);
}

.lt-pp-tally__label {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--lt-pp-muted, #78909c);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark-mode .lt-pp-tally__cell--present,
.lt-pp-sheet.dark-mode .lt-pp-tally__cell--present,
html[data-theme="dark"] .lt-pp-tally__cell--present {
  --lt-pp-tone: #81c784;
}

.dark-mode .lt-pp-tally__cell--unmarked,
.lt-pp-sheet.dark-mode .lt-pp-tally__cell--unmarked,
html[data-theme="dark"] .lt-pp-tally__cell--unmarked {
  --lt-pp-tone: #ffb74d;
}

.dark-mode .lt-pp-tally__cell--absent,
.lt-pp-sheet.dark-mode .lt-pp-tally__cell--absent,
html[data-theme="dark"] .lt-pp-tally__cell--absent {
  --lt-pp-tone: #e57373;
}

.lt-pp-sheet__search-row {
  display: flex;
  gap: 8px;
}

.lt-pp-sheet__search-row .lt-pp-sheet__search {
  flex: 1 1 auto;
  min-width: 0;
}

.lt-pp-sheet__sort {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 44%;
  height: 40px;
  padding: 0 4px 0 10px;
  border: 1px solid var(--lt-pp-border, #e0e6ed);
  border-radius: 12px;
  background: var(--lt-pp-input-bg, #f8fafb);
  color: var(--lt-pp-muted, #78909c);
}

.lt-pp-sheet__sort-icon {
  font-size: 18px !important;
  flex-shrink: 0;
}

.lt-pp-sheet__sort-select {
  min-width: 0;
  max-width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  color: var(--lt-pp-text, #1a2b3c);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  text-overflow: ellipsis;
}

.lt-pp-sheet__sort-select option {
  color: var(--lt-pp-text, #1a2b3c);
  background: var(--lt-pp-bg, #fff);
}

.lt-pp-sheet__search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  height: 40px;
  border: 1px solid var(--lt-pp-border, #e0e6ed);
  border-radius: 12px;
  background: var(--lt-pp-input-bg, #f8fafb);
}

.lt-pp-sheet__search:focus-within {
  border-color: var(--lt-pp-accent);
  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15);
  background: var(--lt-pp-bg, #fff);
}

.lt-pp-sheet__search-icon {
  color: var(--lt-pp-muted, #90a4ae);
  font-size: 20px !important;
  flex-shrink: 0;
}

.lt-pp-sheet__search-input {
  flex: 1 1;
  min-width: 0;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  color: inherit;
  outline: none;
}

.lt-pp-sheet__search-input::placeholder {
  color: var(--lt-pp-muted, #90a4ae);
}

.lt-pp-sheet__filters {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.lt-pp-sheet__filters::-webkit-scrollbar {
  display: none;
}

.lt-pp-sheet__filter {
  flex-shrink: 0;
  padding: 6px 12px;
  border: 1px solid var(--lt-pp-border, #e0e6ed);
  border-radius: 999px;
  background: var(--lt-pp-row-bg, #fff);
  color: var(--lt-pp-muted, #546e7a);
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.lt-pp-sheet__filter--active {
  border-color: var(--lt-pp-accent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
  color: var(--lt-pp-accent);
}

.lt-pp-sheet__option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 10px;
  background: var(--lt-pp-input-bg, #f8fafb);
  border: 1px solid var(--lt-pp-border, #e8edf2);
  font-size: 0.8rem;
  color: var(--lt-pp-muted, #546e7a);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.lt-pp-sheet__option input {
  accent-color: var(--lt-pp-accent);
}

.lt-pp-sheet__alert {
  margin: 0 16px 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 152, 0, 0.12);
  border: 1px solid rgba(255, 152, 0, 0.35);
  color: #e65100;
  font-size: 0.8rem;
  line-height: 1.35;
}

.lt-pp-sheet__alert--error {
  background: rgba(198, 40, 40, 0.1);
  border-color: rgba(198, 40, 40, 0.35);
  color: #c62828;
}

.dark-mode .lt-pp-sheet__alert,
.lt-pp-sheet.dark-mode .lt-pp-sheet__alert,
html[data-theme="dark"] .lt-pp-sheet__alert {
  color: #ffb74d;
}

.dark-mode .lt-pp-sheet__alert--error,
.lt-pp-sheet.dark-mode .lt-pp-sheet__alert--error,
html[data-theme="dark"] .lt-pp-sheet__alert--error {
  color: #ef9a9a;
}

.dark-mode .lt-pp-sheet__invite-error,
.lt-pp-sheet.dark-mode .lt-pp-sheet__invite-error,
html[data-theme="dark"] .lt-pp-sheet__invite-error {
  color: #ef9a9a;
}

.dark-mode .lt-pp-sheet__invite-success,
.lt-pp-sheet.dark-mode .lt-pp-sheet__invite-success,
html[data-theme="dark"] .lt-pp-sheet__invite-success {
  color: #81c784;
}

.lt-pp-sheet__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 0 16px calc(14px + env(safe-area-inset-bottom));
}

/* Section labels stay pinned while the roster scrolls under them. */
.lt-pp-sheet__section-label {
  position: sticky;
  top: 0;
  z-index: 1;
  margin: 0 0 4px;
  padding: 10px 0 6px;
  background: var(--lt-pp-bg, #fff);
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--lt-pp-muted, #90a4ae);
}

.lt-pp-sheet:not(.lt-pp-sheet--nested) {
  height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 9%, transparent) 0,
      transparent 150px
    ),
    var(--lt-pp-bg, #fff);
}

.dark-mode .lt-pp-sheet:not(.lt-pp-sheet--nested),
.lt-pp-sheet.dark-mode:not(.lt-pp-sheet--nested),
html[data-theme="dark"] .lt-pp-sheet:not(.lt-pp-sheet--nested) {
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent) 0,
      transparent 150px
    ),
    var(--lt-pp-bg, #111827);
}

.lt-pp-sheet-portal--landscape .lt-pp-sheet:not(.lt-pp-sheet--nested) {
  height: min(90dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
}

.lt-pp-sheet__loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
}

.lt-pp-sheet__empty {
  text-align: center;
  padding: 28px 12px;
  color: var(--lt-pp-muted, #90a4ae);
  font-size: 0.875rem;
}

.lt-pp-sheet__invite {
  padding: 12px;
  margin-bottom: 12px;
  border-radius: 12px;
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
}

.lt-pp-sheet__invite--nested {
  margin: 12px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
}

.lt-pp-sheet__invite-title {
  margin: 0 0 4px;
  font-size: 0.9rem;
  font-weight: 700;
}

.lt-pp-sheet__invite-hint {
  margin: 0 0 10px;
  font-size: 0.75rem;
  color: var(--lt-pp-muted, #78909c);
  line-height: 1.35;
}

.lt-pp-sheet__invite-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.lt-pp-sheet__invite-input {
  flex: 1 1 120px;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid var(--lt-pp-border, #e0e6ed);
  border-radius: 8px;
  font-size: 0.85rem;
  background: var(--lt-pp-input-bg, #fff);
  color: var(--lt-pp-text, #1a2b3c);
}

.lt-pp-sheet__invite-input--email {
  flex: 1 1 100%;
}

.lt-pp-sheet__invite-input:focus {
  outline: none;
  border-color: var(--lt-pp-accent);
  background: var(--lt-pp-bg, #fff);
}

.lt-pp-sheet__invite-input::placeholder {
  color: var(--lt-pp-muted, #90a4ae);
}

.lt-pp-sheet__invite-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  border: none;
  border-radius: 10px;
  background: var(--brand-primary, #0877bc);
  color: #fff;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
}

.lt-pp-sheet__invite-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.lt-pp-sheet__invite-error {
  margin: 0 0 8px;
  font-size: 0.78rem;
  color: #c62828;
}

.lt-pp-sheet__invite-success {
  margin: 0 0 8px;
  font-size: 0.78rem;
  color: #2e7d32;
}

.lt-pp-sheet__coaches {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.lt-pp-sheet__coach-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px 6px 6px;
  border-radius: 999px;
  background: color-mix(in srgb, var(--lt-pp-accent-2) 12%, var(--lt-pp-bg));
  border: 1px solid color-mix(in srgb, var(--lt-pp-accent-2) 32%, transparent);
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--lt-pp-accent-2);
}

.lt-pp-sheet__coach-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--brand-secondary, #46528b);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.65rem;
  font-weight: 700;
  overflow: hidden;
  flex-shrink: 0;
}

.lt-pp-sheet__coach-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lt-pp-sheet__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-pp-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  background: var(--lt-pp-row-bg, #fff);
  border: 1px solid var(--lt-pp-border, #e8edf2);
  min-height: 52px;
}

.lt-pp-row--present {
  border-left: 3px solid #4caf50;
}

.lt-pp-row--unmarked {
  border-left: 3px solid #ff9800;
}

.lt-pp-row--absent {
  border-left: 3px solid #f44336;
  opacity: 0.88;
}

.lt-pp-row__avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    var(--brand-primary, #0877bc),
    var(--brand-primary-light, var(--brand-primary, #0a8cd8))
  );
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  flex-shrink: 0;
  overflow: hidden;
}

.lt-pp-row__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.lt-pp-row__info {
  flex: 1 1;
  min-width: 0;
}

.lt-pp-row__name {
  display: block;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--lt-pp-text, #1a2b3c);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-pp-row__meta {
  display: block;
  font-size: 0.7rem;
  color: var(--lt-pp-muted, #90a4ae);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-pp-row__badge {
  display: inline-block;
  margin-top: 2px;
  padding: 1px 6px;
  border-radius: 4px;
  background: var(--lt-pp-chip, #eceff1);
  font-size: 0.62rem;
  font-weight: 600;
  color: var(--lt-pp-muted, #607d8b);
}

.lt-pp-row__actions {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.lt-pp-row__btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
}

.lt-pp-row__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.lt-pp-row__btn--add {
  background: rgba(76, 175, 80, 0.12);
  color: #2e7d32;
}

.lt-pp-row__btn--add:hover:not(:disabled) {
  background: rgba(76, 175, 80, 0.22);
}

.lt-pp-row__btn--remove {
  background: rgba(244, 67, 54, 0.1);
  color: #c62828;
}

.lt-pp-row__btn--remove:hover:not(:disabled) {
  background: rgba(244, 67, 54, 0.2);
}

.lt-pp-row__btn--done {
  background: rgba(76, 175, 80, 0.15);
  color: #2e7d32;
  cursor: default;
}

.lt-pp-sheet.dark-mode .lt-pp-row__btn--add,
.lt-pp-sheet.dark-mode .lt-pp-row__btn--done,
.dark-mode .lt-pp-row__btn--add,
.dark-mode .lt-pp-row__btn--done,
html[data-theme="dark"] .lt-pp-row__btn--add,
html[data-theme="dark"] .lt-pp-row__btn--done {
  color: #81c784;
}

.lt-pp-sheet.dark-mode .lt-pp-row__btn--remove,
.dark-mode .lt-pp-row__btn--remove,
html[data-theme="dark"] .lt-pp-row__btn--remove {
  color: #ef9a9a;
}

/* Nested table picker */
.lt-pp-table-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.lt-pp-table-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: 1px solid var(--lt-pp-border, #e0e6ed);
  border-radius: 10px;
  background: var(--lt-pp-row-bg, #fff);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--lt-pp-text, #1a2b3c);
  cursor: pointer;
}

.lt-pp-table-item:hover:not(:disabled) {
  border-color: var(--lt-pp-accent);
  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);
}

.lt-pp-table-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayerPresenceSheet.css"],"names":[],"mappings":"AAEA;yEACyE;;AAEzE;EACE,yCAAyC;EACzC,wCAAwC;EACxC,6CAA6C;EAC7C,4CAA4C;EAC5C,6EAA6E;EAC7E,uEAAuE;EACvE,2EAA2E;EAC3E,+BAA+B;EAC/B,yEAAyE;EACzE,wEAAwE;EACxE,uEAAuE;EACvE,yEAAyE;EACzE,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;;;EAGE,yCAAyC;EACzC,wCAAwC;EACxC,6CAA6C;EAC7C,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,mDAAmD;EACnD,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;;;EAGE,yCAAyC;EACzC,wCAAwC;EACxC,6CAA6C;EAC7C,yCAAyC;EACzC,uCAAuC;EACvC,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,gDAAgD;EAChD,qFAAqF;EACrF,2EAA2E;EAC3E,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,uCAAuC;EACvC,yCAAyC;EACzC,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+DAA+D;EAC/D,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;EAC5B,qEAAqE;EACrE,8DAA8D;EAC9D,wBAAwB;AAC1B;;AAEA;EACE,oGAAoG;EACpG,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0DAA0D;AAC5D;;AAEA,yEAAyE;AACzE;EACE,uEAAuE;EACvE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,mBAAmB;EACnB,oEAAoE;EACpE,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,oFAAoF;AACtF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,2FAA2F;EAC3F,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,4EAA4E;AAC9E;;AAEA;EACE,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,uEAAuE;EACvE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,8CAA8C;EAC9C,oBAAoB;EACpB,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,8CAA8C;EAC9C,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;EACjC,wDAAwD;AAC1D;;AAEA,oEAAoE;AACpE;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,2DAA2D;EAC3D;;;;;;yBAMuB;AACzB;;AAEA;;;EAGE;;;;;;4BAM0B;AAC5B;;AAEA;EACE,gGAAgG;AAClG;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mEAAmE;EACnE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,oBAAoB;EACpB,0EAA0E;EAC1E,4EAA4E;EAC5E,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;GAIC;EACD,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,eAAe;AACjB;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap\");\n\n/* Player presence bottom sheet — live training coach flow\n   Bright + dark via --lt-pp-* tokens (follow BrandContext light/dark). */\n\n.lt-pp-sheet {\n  --lt-pp-bg: var(--surface-color, #ffffff);\n  --lt-pp-text: var(--text-color, #1a2b3c);\n  --lt-pp-muted: var(--text-secondary, #78909c);\n  --lt-pp-border: var(--border-color, #e0e6ed);\n  --lt-pp-border-soft: color-mix(in srgb, var(--lt-pp-border) 80%, transparent);\n  --lt-pp-chip: color-mix(in srgb, var(--lt-pp-text) 5%, var(--lt-pp-bg));\n  --lt-pp-input-bg: color-mix(in srgb, var(--lt-pp-text) 4%, var(--lt-pp-bg));\n  --lt-pp-row-bg: var(--lt-pp-bg);\n  --lt-pp-footer: color-mix(in srgb, var(--lt-pp-text) 3%, var(--lt-pp-bg));\n  --lt-pp-hover: color-mix(in srgb, var(--lt-pp-text) 6%, var(--lt-pp-bg));\n  --lt-pp-handle: color-mix(in srgb, var(--lt-pp-muted) 55%, transparent);\n  --lt-pp-shadow: 0 -12px 40px var(--shadow-color, rgba(8, 119, 188, 0.14));\n  --lt-pp-accent: var(--brand-primary, #0877bc);\n  --lt-pp-accent-2: var(--brand-secondary, #46528b);\n}\n\n.light-mode .lt-pp-sheet,\n.lt-pp-sheet.light-mode,\nhtml[data-theme=\"light\"] .lt-pp-sheet {\n  --lt-pp-bg: var(--surface-color, #ffffff);\n  --lt-pp-text: var(--text-color, #1a2b3c);\n  --lt-pp-muted: var(--text-secondary, #64748b);\n  --lt-pp-border: #e0e6ed;\n  --lt-pp-chip: #f4f7fa;\n  --lt-pp-input-bg: #f8fafb;\n  --lt-pp-row-bg: #ffffff;\n  --lt-pp-footer: #fafbfc;\n  --lt-pp-hover: #f0f4f8;\n  --lt-pp-shadow: 0 -12px 40px rgba(15, 23, 42, 0.12);\n  --lt-pp-accent: var(--brand-primary, #0877bc);\n  --lt-pp-accent-2: var(--brand-secondary, #46528b);\n}\n\n.dark-mode .lt-pp-sheet,\n.lt-pp-sheet.dark-mode,\nhtml[data-theme=\"dark\"] .lt-pp-sheet {\n  --lt-pp-bg: var(--surface-color, #111827);\n  --lt-pp-text: var(--text-color, #f9fafb);\n  --lt-pp-muted: var(--text-secondary, #9ca3af);\n  --lt-pp-border: rgba(255, 255, 255, 0.12);\n  --lt-pp-chip: rgba(255, 255, 255, 0.06);\n  --lt-pp-input-bg: rgba(15, 23, 42, 0.55);\n  --lt-pp-row-bg: rgba(255, 255, 255, 0.04);\n  --lt-pp-footer: rgba(15, 23, 42, 0.92);\n  --lt-pp-hover: rgba(255, 255, 255, 0.08);\n  --lt-pp-handle: rgba(148, 163, 184, 0.45);\n  --lt-pp-shadow: 0 -12px 40px rgba(0, 0, 0, 0.45);\n  /* Club colors lifted toward white so dark palettes stay readable on dark surfaces. */\n  --lt-pp-accent: color-mix(in srgb, var(--brand-primary, #0877bc) 62%, #fff);\n  --lt-pp-accent-2: color-mix(in srgb, var(--brand-secondary, #46528b) 55%, #fff);\n}\n\n.lt-pp-sheet-portal {\n  position: fixed;\n  inset: 0;\n  z-index: 1500;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding-left: env(safe-area-inset-left);\n  padding-right: env(safe-area-inset-right);\n  box-sizing: border-box;\n  animation: lt-pp-backdrop-in 0.22s ease-out;\n}\n\n.light-mode .lt-pp-sheet-portal,\n.lt-pp-sheet-portal.light-mode,\nhtml[data-theme=\"light\"] .lt-pp-sheet-portal {\n  background: rgba(15, 23, 42, 0.4);\n}\n\n.dark-mode .lt-pp-sheet-portal,\n.lt-pp-sheet-portal.dark-mode,\nhtml[data-theme=\"dark\"] .lt-pp-sheet-portal {\n  background: rgba(2, 6, 23, 0.72);\n}\n\n.lt-pp-sheet-portal--landscape {\n  align-items: center;\n  padding-top: max(8px, env(safe-area-inset-top));\n  padding-bottom: max(8px, env(safe-area-inset-bottom));\n}\n\n.lt-pp-sheet-portal--nested {\n  z-index: 1510;\n}\n\n@keyframes lt-pp-backdrop-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.lt-pp-sheet {\n  width: 100%;\n  max-width: min(520px, 100%);\n  max-height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--lt-pp-bg, #fff);\n  color: var(--lt-pp-text, #1a2b3c);\n  border-radius: 20px 20px 0 0;\n  box-shadow: var(--lt-pp-shadow, 0 -12px 40px rgba(8, 119, 188, 0.14));\n  animation: lt-pp-sheet-up 0.32s cubic-bezier(0.32, 0.72, 0, 1);\n  color-scheme: light dark;\n}\n\n.lt-pp-sheet-portal--landscape .lt-pp-sheet {\n  max-height: min(90dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));\n  border-radius: 16px;\n}\n\n.lt-pp-sheet--nested {\n  max-height: min(70dvh, calc(100dvh - env(safe-area-inset-top) - 120px));\n}\n\n@keyframes lt-pp-sheet-up {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n.lt-pp-sheet__handle {\n  flex-shrink: 0;\n  width: 40px;\n  height: 4px;\n  margin: 10px auto 0;\n  border-radius: 999px;\n  background: var(--lt-pp-handle, rgba(120, 144, 156, 0.35));\n}\n\n.lt-pp-sheet__header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px 8px;\n}\n\n.lt-pp-sheet__title-wrap {\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-pp-sheet__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n  line-height: 1.25;\n  color: var(--lt-pp-text, #1a2b3c);\n}\n\n.lt-pp-sheet__subtitle {\n  margin: 2px 0 0;\n  font-size: 0.75rem;\n  color: var(--lt-pp-muted, #78909c);\n  line-height: 1.3;\n}\n\n.lt-pp-sheet__close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--lt-pp-muted, #78909c);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-pp-sheet__close:hover {\n  background: var(--lt-pp-hover, #f0f4f8);\n  color: var(--lt-pp-accent);\n}\n\n.lt-pp-sheet__toolbar {\n  flex-shrink: 0;\n  padding: 0 16px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border-bottom: 1px solid var(--lt-pp-border-soft, #eef2f6);\n}\n\n/* Compact header bar: group + title on the left, actions on the right. */\n.lt-pp-bar {\n  --lt-pp-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px 8px 16px;\n}\n\n.lt-pp-bar__text {\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-pp-bar__kicker {\n  margin: 0;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  line-height: 1.3;\n  color: var(--lt-pp-accent);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-pp-bar__title {\n  margin: 0;\n  font-family: var(--lt-pp-display);\n  font-size: 1.35rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  line-height: 1.05;\n  color: var(--lt-pp-text, #1a2b3c);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-pp-bar__icon-btn {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: 1px solid color-mix(in srgb, var(--lt-pp-accent) 40%, transparent);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--lt-pp-accent) 10%, transparent);\n  color: var(--lt-pp-accent);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.lt-pp-bar__icon-btn:hover {\n  background: color-mix(in srgb, var(--lt-pp-accent) 20%, transparent);\n}\n\n.lt-pp-bar__done {\n  flex-shrink: 0;\n  height: 36px;\n  padding: 0 16px;\n  border: none;\n  border-radius: 10px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 0.85rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.dark-mode .lt-pp-bar__done,\n.lt-pp-sheet.dark-mode .lt-pp-bar__done,\nhtml[data-theme=\"dark\"] .lt-pp-bar__done {\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--lt-pp-accent) 55%, transparent);\n}\n\n.lt-pp-bar__done:hover {\n  filter: brightness(1.06);\n}\n\n.lt-pp-bar__icon-btn:focus-visible,\n.lt-pp-bar__done:focus-visible,\n.lt-pp-tally__cell:focus-visible,\n.lt-pp-sheet__sort-select:focus-visible {\n  outline: 2px solid var(--lt-pp-accent);\n  outline-offset: 2px;\n}\n\n/* Scoreboard tally: each cell filters the list; tap again to show all. */\n.lt-pp-tally {\n  display: flex;\n  border: 1px solid color-mix(in srgb, var(--lt-pp-accent) 30%, var(--lt-pp-border, #e0e6ed));\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.lt-pp-tally__cell {\n  --lt-pp-tone: #2e7d32;\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 8px;\n  border: none;\n  border-top: 3px solid transparent;\n  background: var(--lt-pp-row-bg, #fff);\n  font: inherit;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.lt-pp-tally__cell + .lt-pp-tally__cell {\n  border-left: 1px solid var(--lt-pp-border, #e0e6ed);\n}\n\n.lt-pp-tally__cell--unmarked {\n  --lt-pp-tone: #e65100;\n}\n\n.lt-pp-tally__cell--absent {\n  --lt-pp-tone: #c62828;\n}\n\n.lt-pp-tally__cell--active {\n  border-top-color: var(--lt-pp-tone);\n  background: color-mix(in srgb, var(--lt-pp-tone) 10%, var(--lt-pp-bg, #fff));\n}\n\n.lt-pp-tally__value {\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.3rem;\n  font-weight: 700;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n  color: var(--lt-pp-tone);\n}\n\n.lt-pp-tally__label {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--lt-pp-muted, #78909c);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark-mode .lt-pp-tally__cell--present,\n.lt-pp-sheet.dark-mode .lt-pp-tally__cell--present,\nhtml[data-theme=\"dark\"] .lt-pp-tally__cell--present {\n  --lt-pp-tone: #81c784;\n}\n\n.dark-mode .lt-pp-tally__cell--unmarked,\n.lt-pp-sheet.dark-mode .lt-pp-tally__cell--unmarked,\nhtml[data-theme=\"dark\"] .lt-pp-tally__cell--unmarked {\n  --lt-pp-tone: #ffb74d;\n}\n\n.dark-mode .lt-pp-tally__cell--absent,\n.lt-pp-sheet.dark-mode .lt-pp-tally__cell--absent,\nhtml[data-theme=\"dark\"] .lt-pp-tally__cell--absent {\n  --lt-pp-tone: #e57373;\n}\n\n.lt-pp-sheet__search-row {\n  display: flex;\n  gap: 8px;\n}\n\n.lt-pp-sheet__search-row .lt-pp-sheet__search {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.lt-pp-sheet__sort {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 44%;\n  height: 40px;\n  padding: 0 4px 0 10px;\n  border: 1px solid var(--lt-pp-border, #e0e6ed);\n  border-radius: 12px;\n  background: var(--lt-pp-input-bg, #f8fafb);\n  color: var(--lt-pp-muted, #78909c);\n}\n\n.lt-pp-sheet__sort-icon {\n  font-size: 18px !important;\n  flex-shrink: 0;\n}\n\n.lt-pp-sheet__sort-select {\n  min-width: 0;\n  max-width: 100%;\n  height: 100%;\n  border: none;\n  background: transparent;\n  color: var(--lt-pp-text, #1a2b3c);\n  font: inherit;\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  text-overflow: ellipsis;\n}\n\n.lt-pp-sheet__sort-select option {\n  color: var(--lt-pp-text, #1a2b3c);\n  background: var(--lt-pp-bg, #fff);\n}\n\n.lt-pp-sheet__search {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 12px;\n  height: 40px;\n  border: 1px solid var(--lt-pp-border, #e0e6ed);\n  border-radius: 12px;\n  background: var(--lt-pp-input-bg, #f8fafb);\n}\n\n.lt-pp-sheet__search:focus-within {\n  border-color: var(--lt-pp-accent);\n  box-shadow: 0 0 0 2px rgba(var(--brand-primary-rgb, 8, 119, 188), 0.15);\n  background: var(--lt-pp-bg, #fff);\n}\n\n.lt-pp-sheet__search-icon {\n  color: var(--lt-pp-muted, #90a4ae);\n  font-size: 20px !important;\n  flex-shrink: 0;\n}\n\n.lt-pp-sheet__search-input {\n  flex: 1;\n  min-width: 0;\n  border: none;\n  background: transparent;\n  font-size: 0.9rem;\n  color: inherit;\n  outline: none;\n}\n\n.lt-pp-sheet__search-input::placeholder {\n  color: var(--lt-pp-muted, #90a4ae);\n}\n\n.lt-pp-sheet__filters {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n.lt-pp-sheet__filters::-webkit-scrollbar {\n  display: none;\n}\n\n.lt-pp-sheet__filter {\n  flex-shrink: 0;\n  padding: 6px 12px;\n  border: 1px solid var(--lt-pp-border, #e0e6ed);\n  border-radius: 999px;\n  background: var(--lt-pp-row-bg, #fff);\n  color: var(--lt-pp-muted, #546e7a);\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.lt-pp-sheet__filter--active {\n  border-color: var(--lt-pp-accent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n  color: var(--lt-pp-accent);\n}\n\n.lt-pp-sheet__option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: var(--lt-pp-input-bg, #f8fafb);\n  border: 1px solid var(--lt-pp-border, #e8edf2);\n  font-size: 0.8rem;\n  color: var(--lt-pp-muted, #546e7a);\n  cursor: pointer;\n  user-select: none;\n}\n\n.lt-pp-sheet__option input {\n  accent-color: var(--lt-pp-accent);\n}\n\n.lt-pp-sheet__alert {\n  margin: 0 16px 8px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(255, 152, 0, 0.12);\n  border: 1px solid rgba(255, 152, 0, 0.35);\n  color: #e65100;\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.lt-pp-sheet__alert--error {\n  background: rgba(198, 40, 40, 0.1);\n  border-color: rgba(198, 40, 40, 0.35);\n  color: #c62828;\n}\n\n.dark-mode .lt-pp-sheet__alert,\n.lt-pp-sheet.dark-mode .lt-pp-sheet__alert,\nhtml[data-theme=\"dark\"] .lt-pp-sheet__alert {\n  color: #ffb74d;\n}\n\n.dark-mode .lt-pp-sheet__alert--error,\n.lt-pp-sheet.dark-mode .lt-pp-sheet__alert--error,\nhtml[data-theme=\"dark\"] .lt-pp-sheet__alert--error {\n  color: #ef9a9a;\n}\n\n.dark-mode .lt-pp-sheet__invite-error,\n.lt-pp-sheet.dark-mode .lt-pp-sheet__invite-error,\nhtml[data-theme=\"dark\"] .lt-pp-sheet__invite-error {\n  color: #ef9a9a;\n}\n\n.dark-mode .lt-pp-sheet__invite-success,\n.lt-pp-sheet.dark-mode .lt-pp-sheet__invite-success,\nhtml[data-theme=\"dark\"] .lt-pp-sheet__invite-success {\n  color: #81c784;\n}\n\n.lt-pp-sheet__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  padding: 0 16px calc(14px + env(safe-area-inset-bottom));\n}\n\n/* Section labels stay pinned while the roster scrolls under them. */\n.lt-pp-sheet__section-label {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  margin: 0 0 4px;\n  padding: 10px 0 6px;\n  background: var(--lt-pp-bg, #fff);\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--lt-pp-muted, #90a4ae);\n}\n\n.lt-pp-sheet:not(.lt-pp-sheet--nested) {\n  height: min(92dvh, calc(100dvh - env(safe-area-inset-top)));\n  background:\n    linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 9%, transparent) 0,\n      transparent 150px\n    ),\n    var(--lt-pp-bg, #fff);\n}\n\n.dark-mode .lt-pp-sheet:not(.lt-pp-sheet--nested),\n.lt-pp-sheet.dark-mode:not(.lt-pp-sheet--nested),\nhtml[data-theme=\"dark\"] .lt-pp-sheet:not(.lt-pp-sheet--nested) {\n  background:\n    linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 20%, transparent) 0,\n      transparent 150px\n    ),\n    var(--lt-pp-bg, #111827);\n}\n\n.lt-pp-sheet-portal--landscape .lt-pp-sheet:not(.lt-pp-sheet--nested) {\n  height: min(90dvh, calc(100dvh - 24px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));\n}\n\n.lt-pp-sheet__loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 160px;\n}\n\n.lt-pp-sheet__empty {\n  text-align: center;\n  padding: 28px 12px;\n  color: var(--lt-pp-muted, #90a4ae);\n  font-size: 0.875rem;\n}\n\n.lt-pp-sheet__invite {\n  padding: 12px;\n  margin-bottom: 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.35);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n}\n\n.lt-pp-sheet__invite--nested {\n  margin: 12px 0 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n}\n\n.lt-pp-sheet__invite-title {\n  margin: 0 0 4px;\n  font-size: 0.9rem;\n  font-weight: 700;\n}\n\n.lt-pp-sheet__invite-hint {\n  margin: 0 0 10px;\n  font-size: 0.75rem;\n  color: var(--lt-pp-muted, #78909c);\n  line-height: 1.35;\n}\n\n.lt-pp-sheet__invite-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.lt-pp-sheet__invite-input {\n  flex: 1 1 120px;\n  min-width: 0;\n  padding: 8px 10px;\n  border: 1px solid var(--lt-pp-border, #e0e6ed);\n  border-radius: 8px;\n  font-size: 0.85rem;\n  background: var(--lt-pp-input-bg, #fff);\n  color: var(--lt-pp-text, #1a2b3c);\n}\n\n.lt-pp-sheet__invite-input--email {\n  flex: 1 1 100%;\n}\n\n.lt-pp-sheet__invite-input:focus {\n  outline: none;\n  border-color: var(--lt-pp-accent);\n  background: var(--lt-pp-bg, #fff);\n}\n\n.lt-pp-sheet__invite-input::placeholder {\n  color: var(--lt-pp-muted, #90a4ae);\n}\n\n.lt-pp-sheet__invite-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  border: none;\n  border-radius: 10px;\n  background: var(--brand-primary, #0877bc);\n  color: #fff;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.lt-pp-sheet__invite-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.lt-pp-sheet__invite-error {\n  margin: 0 0 8px;\n  font-size: 0.78rem;\n  color: #c62828;\n}\n\n.lt-pp-sheet__invite-success {\n  margin: 0 0 8px;\n  font-size: 0.78rem;\n  color: #2e7d32;\n}\n\n.lt-pp-sheet__coaches {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 4px;\n}\n\n.lt-pp-sheet__coach-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px 6px 6px;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--lt-pp-accent-2) 12%, var(--lt-pp-bg));\n  border: 1px solid color-mix(in srgb, var(--lt-pp-accent-2) 32%, transparent);\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--lt-pp-accent-2);\n}\n\n.lt-pp-sheet__coach-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--brand-secondary, #46528b);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.65rem;\n  font-weight: 700;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.lt-pp-sheet__coach-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lt-pp-sheet__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-pp-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px;\n  border-radius: 12px;\n  background: var(--lt-pp-row-bg, #fff);\n  border: 1px solid var(--lt-pp-border, #e8edf2);\n  min-height: 52px;\n}\n\n.lt-pp-row--present {\n  border-left: 3px solid #4caf50;\n}\n\n.lt-pp-row--unmarked {\n  border-left: 3px solid #ff9800;\n}\n\n.lt-pp-row--absent {\n  border-left: 3px solid #f44336;\n  opacity: 0.88;\n}\n\n.lt-pp-row__avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: linear-gradient(\n    135deg,\n    var(--brand-primary, #0877bc),\n    var(--brand-primary-light, var(--brand-primary, #0a8cd8))\n  );\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.8rem;\n  font-weight: 700;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.lt-pp-row__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.lt-pp-row__info {\n  flex: 1;\n  min-width: 0;\n}\n\n.lt-pp-row__name {\n  display: block;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--lt-pp-text, #1a2b3c);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-pp-row__meta {\n  display: block;\n  font-size: 0.7rem;\n  color: var(--lt-pp-muted, #90a4ae);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-pp-row__badge {\n  display: inline-block;\n  margin-top: 2px;\n  padding: 1px 6px;\n  border-radius: 4px;\n  background: var(--lt-pp-chip, #eceff1);\n  font-size: 0.62rem;\n  font-weight: 600;\n  color: var(--lt-pp-muted, #607d8b);\n}\n\n.lt-pp-row__actions {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.lt-pp-row__btn {\n  width: 34px;\n  height: 34px;\n  border: none;\n  border-radius: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.lt-pp-row__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.lt-pp-row__btn--add {\n  background: rgba(76, 175, 80, 0.12);\n  color: #2e7d32;\n}\n\n.lt-pp-row__btn--add:hover:not(:disabled) {\n  background: rgba(76, 175, 80, 0.22);\n}\n\n.lt-pp-row__btn--remove {\n  background: rgba(244, 67, 54, 0.1);\n  color: #c62828;\n}\n\n.lt-pp-row__btn--remove:hover:not(:disabled) {\n  background: rgba(244, 67, 54, 0.2);\n}\n\n.lt-pp-row__btn--done {\n  background: rgba(76, 175, 80, 0.15);\n  color: #2e7d32;\n  cursor: default;\n}\n\n.lt-pp-sheet.dark-mode .lt-pp-row__btn--add,\n.lt-pp-sheet.dark-mode .lt-pp-row__btn--done,\n.dark-mode .lt-pp-row__btn--add,\n.dark-mode .lt-pp-row__btn--done,\nhtml[data-theme=\"dark\"] .lt-pp-row__btn--add,\nhtml[data-theme=\"dark\"] .lt-pp-row__btn--done {\n  color: #81c784;\n}\n\n.lt-pp-sheet.dark-mode .lt-pp-row__btn--remove,\n.dark-mode .lt-pp-row__btn--remove,\nhtml[data-theme=\"dark\"] .lt-pp-row__btn--remove {\n  color: #ef9a9a;\n}\n\n/* Nested table picker */\n.lt-pp-table-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.lt-pp-table-item {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px 14px;\n  border: 1px solid var(--lt-pp-border, #e0e6ed);\n  border-radius: 10px;\n  background: var(--lt-pp-row-bg, #fff);\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--lt-pp-text, #1a2b3c);\n  cursor: pointer;\n}\n\n.lt-pp-table-item:hover:not(:disabled) {\n  border-color: var(--lt-pp-accent);\n  background: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.06);\n}\n\n.lt-pp-table-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
